import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserState {
  value: any;
}

const initialState: IUserState = {
  value: null
};

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<any>) => {
      state.value = action.payload;
    }
  }
});

export const { setCurrentUser } = currentUserSlice.actions;

export default currentUserSlice.reducer;